import { render, staticRenderFns } from "./righttablelist.vue?vue&type=template&id=8241b748&scoped=true&"
import script from "./righttablelist.vue?vue&type=script&lang=js&"
export * from "./righttablelist.vue?vue&type=script&lang=js&"
import style0 from "./righttablelist.vue?vue&type=style&index=0&id=8241b748&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8241b748",
  null
  
)

export default component.exports